// extracted by mini-css-extract-plugin
export default {"cardWallet":"CardSupport_cardWallet__R6y7v","title":"CardSupport_title__ob66h","subtitle":"CardSupport_subtitle__vnfGH","optionCard":"CardSupport_optionCard__LpWjQ"};